<template>
<div class="pony-info-section">
  <InfoSectionHeading>Pony Details</InfoSectionHeading>
  <div class="pony-details">
    <ul class="details-list">
      <li v-if="pony.grouping" class="pony-detail">
        <p>
          <span class="elr-bold">Grouping:</span>
          <router-link :to="`/grouping/${pony.grouping.id}`">{{capitalize(pony.grouping.name)}}</router-link>
        </p>
      </li>
      <li v-if="pony.pose" class="pony-detail">
        <p>
          <span class="elr-bold">Pose:</span>
          <router-link :to="`/pose/${pony.pose.id}`">{{capitalize(pony.pose.name)}}</router-link>
        </p>
      </li>
      <li v-if="pony.body_color" class="pony-detail">
        <p>
          <span class="elr-bold">Body Color:</span>
          <router-link :to="`/body-color/${pony.body_color.id}`">{{capitalize(pony.body_color.name)}}</router-link>
        </p>
      </li>
      <li class="pony-detail">
        <p>
          <span class="elr-bold">Body Texture:</span>
          <router-link :to="bodyTextureUrl">{{capitalize(pony.body_texture)}}</router-link>
        </p>
      </li>
      <li v-if="pony.symbol_description" class="pony-detail">
          <p>
              <span class="elr-bold">Symbol:</span>
              {{pony.symbol_description}}
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Symbol Type:</span>
              <router-link :to="symbolTypeUrl">{{capitalize(pony.symbol_type)}}</router-link>
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Symbol Texture:</span>
              <router-link :to="symbolTextureUrl">{{capitalize(pony.symbol_texture)}}</router-link>
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Freckle Color:</span>
              {{capitalize(pony.freckle_color)}}
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Age:</span>
              <router-link :to="ageUrl">{{capitalize(pony.age)}}</router-link>
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Gender:</span>
              <router-link :to="genderUrl">{{capitalize(pony.gender)}}</router-link>
          </p>
      </li>
      <li v-if="pony.mold" class="pony-detail">
          <p>
              <span class="elr-bold">Mold:</span>
              <router-link :to="`/mold/${pony.mold.id}`">{{capitalize(pony.mold.name)}}</router-link>
          </p>
      </li>
      <li v-if="pony.themes" class="pony-detail">
        <p>
          <span class="elr-bold">Themes:</span>
          <span v-for="(theme, index) in pony.themes" :key="theme.id"><router-link :to="`/theme/${theme.id}`">{{capitalize(theme.name)}}</router-link>{{index !== pony.themes.length - 1 ? ',': ''}}</span>
        </p>
      </li>
    </ul>
    <ul class="details-list">
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Eye Color:</span>
              {{capitalize(pony.eye_color)}}
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Eye Type:</span>
              {{capitalize(pony.eye_type)}}
          </p>
      </li>
      <li v-if="pony.hair_colors" class="pony-detail">
        <p>
          <span class="elr-bold">Hair Colors:</span>
          <span v-for="(hairColor, index) in pony.hair_colors" :key="hairColor.id"><router-link :to="`/hair-color/${hairColor.id}`">{{capitalize(hairColor.name)}}</router-link>{{index !== pony.hair_colors.length - 1 ? ',': ''}}</span>
        </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Hair Texture:</span>
              {{capitalize(pony.hair_texture)}}
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Hair Length:</span>
              {{capitalize(pony.hair_length)}}
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Hoof Mark Decoration:</span>
              {{capitalize(pony.hoof_mark_decoration)}}
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Patent Status:</span>
              {{capitalize(pony.patent_status)}}
          </p>
      </li>
      <li class="pony-detail">
          <p>
              <span class="elr-bold">Hoof Style:</span>
              {{capitalize(pony.hoof_style)}}
          </p>
      </li>
      <li class="pony-detail">
          <p><span class="elr-bold">Notes:</span> {{pony.notes}}</p>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import { slugify, capitalize } from '../../utils/helpers';
import InfoSectionHeading from '../InfoSectionHeading/InfoSectionHeading';

export default {
  name: 'PonyInfo',
  props: {
    pony: {
      type: Object,
      required: true
    }
  },
  components: {
    InfoSectionHeading
  },
  computed: {
    bodyTextureUrl() {
      return `/list/body-texture/${slugify(this.pony.body_texture)}/ponies`;
    },
    symbolTypeUrl() {
      return `/list/symbol-type/${slugify(this.pony.symbol_type)}/ponies`;
    },
    symbolTextureUrl() {
      return `/list/symbol-texture/${slugify(this.pony.symbol_texture)}/ponies`;
    },
    ageUrl() {
      return `/list/age/${slugify(this.pony.age)}/ponies`;
    },
    genderUrl() {
      return `/list/gender/${slugify(this.pony.gender)}/ponies`;
    }
  },
  methods: {
    capitalize
  }
};
</script>
